import React, { useState } from 'react'
import { useHistory, Redirect } from 'react-router-dom'

function Header() {
    const history = useHistory();
    const [close, SetClose] = useState(false);

    if (close) {
        return <Redirect to="/" />
    }

    return (
        <header className="fixed header-blue">
            <div className="container">
                <div className="header-top">
                    <div className="header-top-left">
                        <span className="back"><img className="img-dark" src="/images/arrow-back.png" alt="" />
                            <img className="img-white" src="/images/arrow-back-white.png" alt="" onClick={() => SetClose(true)} />
                        </span>
                    </div>
                    <div className="header-top-mid">
                        <span className="font-semibold">Order Details</span>
                    </div>
                    <div className="header-top-right"></div>
                </div>
            </div>
        </header>
    )
}

export default Header
